import { ClientState, ClientTypes } from '../actions/clients/clients.d';
import {
  FETCH_CLIENTS_COMPLETED,
  FETCH_CLIENTS_ERROR,
  FETCH_CLIENTS_STARTED,
  UPDATE_CLIENTS_CURRENT_PAGE,
  UPDATE_CLIENTS_PAGE_SIZE,
  ADD_CLIENT_SEARCH,
  CLEAR_CLIENT_SEARCH,
  UPDATE_CLIENT_COLUMN_SORT,
  CLEAR_CLIENT_COLUMN_SORT,
} from 'redux/actionTypes/clients';

const INITIAL_STATE: ClientState = {
  data: [],
  error: false,
  submitted: false,
  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
    nextPage: 0,
    prevPage: null,
    isFirstPage: false,
    isLastPage: false,
    startAt: null,
    endAt: null,
  },
  q: '',
  sorted: [],
};

function clientsReducer(state = INITIAL_STATE, action: ClientTypes): ClientState {
  switch (action.type) {
    case FETCH_CLIENTS_STARTED: {
      return {
        ...state,
        submitted: true,
      };
    }

    case FETCH_CLIENTS_COMPLETED: {
      return {
        ...state,
        ...action.payload,
        submitted: false,
      };
    }

    case FETCH_CLIENTS_ERROR: {
      return {
        ...state,
        error: true,
        submitted: false,
      };
    }

    case UPDATE_CLIENTS_CURRENT_PAGE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.currentPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case UPDATE_CLIENTS_PAGE_SIZE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.perPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case ADD_CLIENT_SEARCH: {
      return {
        ...state,
        q: action.payload,
      };
    }

    case CLEAR_CLIENT_SEARCH: {
      return {
        ...state,
        q: '',
      };
    }

    case UPDATE_CLIENT_COLUMN_SORT: {
      return {
        ...state,
        sorted: action.payload,
      };
    }

    case CLEAR_CLIENT_COLUMN_SORT: {
      return {
        ...state,
        sorted: [],
      };
    }

    default:
      return state;
  }
}

export default clientsReducer;
